import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import ContractTrackingForm from "./routes/ContractTrackForm";
export default store => {
  return {
    path: "contract-tracking",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(
            /* webpackChunkName: "administrator-tooling" */ "./ContractTracking"
          ),
          import(
            /* webpackChunkName: "administrator-tooling" */ "./modules/ContractTrackModule"
          ),
        ]).then(([importedModule0, importedModule1]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          injectReducer(store, {
            key: "schoolContractTrack",
            reducer,
          });
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [ContractTrackingForm(store)],
  };
};
